import { Injectable } from '@angular/core';

import { BaseService } from '../abstracts/base.service';
import { ClassroomModel } from '../models/classroom.model';
import { ResultModel } from '../models/result.model';
@Injectable({
  providedIn: 'root'
})
export class ClassroomService extends BaseService {

  listAllForSelect() {
    return this.httpClient.get<ResultModel<ClassroomModel[]>>(this.getApiUrl('classrooms'));
  }

  listAll(formData?:FormData) {
    return this.httpClient.post<ResultModel<ClassroomModel[]>>(this.getApiUrl('classrooms/list'), formData);
  }

  create(classroom: ClassroomModel) {
    return this.httpClient.post<ResultModel>(this.getApiUrl('classrooms'), classroom);
  }

  update(classroom: ClassroomModel) {
    return this.httpClient.put(this.getApiUrl('classrooms'), classroom);
  }

  get(id:string) {
    return this.httpClient.get<{ Classroom: ClassroomModel }>(this.getApiUrl('classrooms/' + id));
  }

  delete(id:string) {
    return this.httpClient.delete<ResultModel>(this.getApiUrl('classrooms/' + id));
  }

}
